<script setup lang="ts">
import { toRefs } from "vue";
import { RouterLink } from "vue-router";
import { utc2local } from "@/utils";
import type { LegacyDevice } from "@/rvapi";

const props = defineProps<{
  legacyDevices: LegacyDevice[];
  searching: boolean;
}>();

const { legacyDevices, searching } = toRefs(props);
</script>

<template>
  <section v-show="!searching && legacyDevices.length > 0">
    <h3>Legacy Device</h3>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>Ref.</th>
            <th>Email</th>
            <th>Newsletter</th>
            <th>Device</th>
            <th>Last used</th>
            <th>Balance</th>
            <th>Language</th>
            <th>App</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="device in legacyDevices" :key="device.deviceId">
            <td>{{ device.customerNo }}</td>
            <td>{{ device.email }}</td>
            <td>{{ device.newsletter }}</td>
            <td>
              <RouterLink :to="'/legacydevice/' + device.deviceId">{{
                device.deviceId?.substring(0, 8) + "..."
              }}</RouterLink>
            </td>
            <td>{{ utc2local(device.lastRegisterDeviceDate) }}</td>
            <td>{{ device.deviceBalance }}</td>
            <td>{{ device.languageIsoCode }} {{ device.region }}</td>
            <td>
              {{ device.appName }} {{ device.appVersion }} {{ device.appStore }}
            </td>
            <td>
              {{ device.deviceType }}
              {{ device.deviceVersion }}
              {{ device.deviceDescription }}
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
